import { Grid } from '@material-ui/core';
import React from 'react';
import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SamDevNlPrintingFrontProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlPrintingFront: React.FC<SamDevNlPrintingFrontProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12} sm={12}>
          <CheckBoxFastField disabled={isCrtLocked} name="printingFront" label="Front" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2} />
        <Grid item xs={4}>
          Color
        </Grid>
        <Grid item xs={4}>
          Pantone
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="printingFProcess"
            label="Process"
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFProcessColor"
            label="Color"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFProcessPantone"
            label="Pantone"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="printingFSolid" label="Solid" />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFSolidColor"
            label="Color"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFSolidPantone"
            label="Pantone"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="printingFMetalic"
            label="Metalic"
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFMetalicColor"
            label="Color"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFMetalicPantone"
            label="Pantone"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="printingFFoil" label="Foil" />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFFoilColor"
            label="Color"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFFoilPantone"
            label="Pantone"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="printingFOther" label="Other" />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFOtherColor"
            label="Color"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="printingFOtherPantone"
            label="Pantone"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlPrintingFront;
